import React from "react";
import { Link } from "gatsby";

const NewsCard = ({ node, key, className }) => (
  <Link
    to={node.fields.slug}
    className={`flex items-center duration-150 ease-out transform border-2 bg-white border-black cursor-pointer hover:shadow-xl group ${className || ""}`}
    key={key}
  >
    <p
      className="block rotate-180 uppercase text-xs md:text-sm tracking-wide ml-3"
      style={{
        writingMode: "vertical-lr",
        textOrientation: "sideways",
      }}
    >
      {node.frontmatter.category}
    </p>
    <div className="px-3 py-8 xl:py-12">
      <p className="mb-2 text-sm font-medium tracking-widest text-grey-600">
        {node.frontmatter.date}
      </p>
      <h2 className="mb-2 text-2xl font-bold leading-tight tracking-tight">
        {node.frontmatter.title}
      </h2>
      <p className="text-grey-700">
        <span>{node.frontmatter.summary}</span>
      </p>
    </div>
  </Link>
);

export default NewsCard;
